import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from './Style';
import { TableCell, TableRow } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import AddIcon from '@material-ui/icons/Add';
import { ESTIMATE_ITEM_MAX } from '../../const/Const';

type Tprops = {
  layer: number;
  itemName: string[];
  itemLength: number;
  addNewItem: any;
  index?: number;
  thirdIndex?: number;
  fourthIndex?: number;
};

export const Breadcrumbs: React.FC<Tprops> = (props: Tprops) => {
  const {
    layer,
    itemName,
    itemLength,
    addNewItem,
    index,
    thirdIndex,
    fourthIndex
  } = props;
  const classes = useStyles();

  return (
    <>
      <TableRow>
        <StyledTableCell
          align='center'
          style={{
            backgroundColor: '#FFFFFF'
          }}
          colSpan={12}
        >
          <div className={classes.breadcrumbsArea}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                marginTop: 18
              }}
            >
              {itemName.map((name: string) => (
                <div className={classes.itemNames}>
                  <div>{name}</div>
                  <div style={{ marginRight: 12, marginLeft: 12 }}>
                    <NavigateNextIcon />
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex' }}>
              {itemLength < ESTIMATE_ITEM_MAX && (
                <div
                  className={classes.addText}
                  onClick={() => {
                    addNewItem(layer, index, thirdIndex, fourthIndex);
                  }}
                >
                  <AddIcon />
                  <span style={{ marginLeft: 8, marginBottom: 2 }}>
                    この階層の項目を追加する
                  </span>
                </div>
              )}
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: '1px #CCCCCC solid'
  },
  body: {
    fontSize: 12,
    padding: 0,
    height: 12,
    borderRight: '1px #CCCCCC solid'
  }
}))(TableCell);
